module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/motivo-inativacao/motivo-inativacao.component.css
// module id = ./src/app/motivo-inativacao/motivo-inativacao.component.css
// module chunks = main